import { Switch, Space, Row, Col, Button } from "antd";
import { __product } from "../front/catalog/product/__product";
import { storeLocal } from "../helpers/stores";
import i from "../translations/i";
import { ErrorByPricingPlan } from "./ErrorByPricingPlan";
import React from "react";

export const SwitchBlock = ({ array, newDesign = false }: { array: any[], newDesign?: boolean }) => {

    return(
        <div className="switch_block">
            {array.map((el: any, i: number) => el.block ? (
              <ErrorByPricingPlan
                plan={el.block}
                content={newDesign ? <NewSwitchBlock element={el} disabled={el.disabled ? el.disabled : (storeLocal.get('pricing_plan') < el.block)} /> :
                    <div className={`switch_block_element${el.disabled ? ' is-disabled' : ''}`} key={i}>
                        <Row justify="space-between" align="middle" gutter={[16, 0]} wrap={false}>
                            <Col span={18}>
                                <p className="switch_block_element-title">{el.label}</p>
                                {el.description ? <p>{el.description}</p> : <></>}
                            </Col>
                            <Col className="right">
                                <Switch
                                  size="small"
                                  onClick={(e) => el.click(e)}
                                  checked={el.value}
                                  disabled={el.disabled ? el.disabled : (storeLocal.get('pricing_plan') < el.block)}
                                />
                            </Col>
                        </Row>
                    </div>
                }
              />) : (newDesign ? <NewSwitchBlock element={el} /> : (
                <div className={`switch_block_element${el.disabled ? ' is-disabled' : ''}`} key={i}>
                    <Row justify="space-between" align="middle" gutter={[16, 0]} wrap={false}>
                        <Col span={18}>
                            <p className="switch_block_element-title">{el.label}</p>
                            {el.description ? <p>{el.description}</p> : <></>}
                        </Col>
                        <Col className="right">
                            <Switch size="small" onClick={(e) => el.click(e)} checked={el.value} disabled={el.disabled ?? false} />
                        </Col>
                    </Row>
                </div>
            )))}
        </div>
    )
}

const NewSwitchBlock = ({ element, block = null, disabled = false }: any) => {

    return(
      <>
          <div className="switch_block_element_new">
              <Row justify="space-around" align="middle" gutter={[10, 10]}>
                  <Col span={24}>
                      <Switch size="small" onClick={(e) => element.click(e)} checked={element.value} disabled={(element.disabled || disabled) ?? false} />
                  </Col>
                  <Col span={24}>
                      <p className="switch-text-title">{element.label}</p>
                      {element.description ? <p>{element.description}</p> : <></>}
                  </Col>
              </Row>
          </div>
      </>
    )
}